var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner alert-settings-form",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "margin-left": "-32px !important" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card content-wrapper" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.AlertContentConfiguration")
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_WarningSwitch")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.open,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "open", $$v)
                                },
                                expression: "form.open"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_StartAlert"))
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CloseAlert"))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_WarningConditions")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "default-value": _vm.form.warningDateField,
                              "static-options": _vm.alertTypes,
                              "tag-value": "code",
                              filterable: "",
                              "filter-type": "global",
                              cache: false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.warningDateField = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showNodeStatus,
                              expression: "showNodeStatus"
                            }
                          ],
                          attrs: { label: _vm.$t("Sop.SelectTheNode") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              "default-value":
                                _vm.form.triggerTrackingDetailUuid,
                              "static-options": _vm.completeNodeStatus,
                              cache: false,
                              filterable: "",
                              "filter-type": "global",
                              "tag-value": "trackingDetailUuid",
                              "custom-label": function(item) {
                                return (
                                  item.codeCname + "(" + item.subCodeCname + ")"
                                )
                              }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.triggerTrackingDetailUuid = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_WarningContent")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "240px" },
                            model: {
                              value: _vm.form.content,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "content", $$v)
                              },
                              expression: "form.content"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_AutoIgnoreMode")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.ignoreType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ignoreType", $$v)
                                },
                                expression: "form.ignoreType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_EarlyTimedIgnore")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_TurnOffAutoIgnore")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_IgnoreTime") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "120px !important" },
                                attrs: {
                                  disabled: _vm.form.ignoreType === 0,
                                  oninput: "value=value.replace(/[^\\d]/g,'')",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.form.ignoreTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ignoreTime", $$v)
                                  },
                                  expression: "form.ignoreTime"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "5px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_AutomaticallyIgnoreAfterHours"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ApplicationScope")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: !!_vm.form.triggerTrackingDetailUuid
                              },
                              model: {
                                value: _vm.ignoreMode,
                                callback: function($$v) {
                                  _vm.ignoreMode = $$v
                                },
                                expression: "ignoreMode"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-bottom": "5px" },
                                  attrs: { label: true }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ApplyToAllTemplates"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_UseOnlyTheCurrentTemplate"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_DocumentNotification")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.notifyJobType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyJobType", $$v)
                                },
                                expression: "form.notifyJobType"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-bottom": "5px" },
                                  attrs: { label: 0 }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_NoticeOfEachBill")
                                    )
                                  )
                                ]
                              ),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_NoNoticeOfTickets")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_RemarksInfo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.form.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-card",
                {
                  staticClass: "box-card content-wrapper",
                  staticStyle: {
                    "margin-left": "5px",
                    width: "430px !important"
                  }
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v(
                        _vm._s(
                          this.$t("SystemMaintenance.AlertTimeConfiguration")
                        )
                      )
                    ])
                  ]),
                  _vm._l(_vm.warningRuleItemList, function(item, index) {
                    return _c(
                      "el-form",
                      {
                        key: index,
                        staticStyle: { "padding-left": "6px" },
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "80px",
                          "label-position": "left"
                        }
                      },
                      [
                        item.ruleItem
                          ? _c(
                              "div",
                              { staticStyle: { "margin-left": "-25px" } },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "5px" } },
                                  [
                                    index + 1 ===
                                      _vm.warningRuleItemList.length &&
                                    _vm.warningRuleItemList.length !== 3
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "form-operator",
                                            on: {
                                              click: function($event) {
                                                return _vm.onAdd()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.readonly
                                                ? "readonly-operator"
                                                : "el-icon-circle-plus"
                                            })
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "form-operator",
                                            on: {
                                              click: function($event) {
                                                return _vm.onRemove(item, index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.readonly
                                                ? "readonly-operator"
                                                : "el-icon-remove"
                                            })
                                          ]
                                        ),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "100px",
                                          "margin-right": "5px"
                                        },
                                        model: {
                                          value: item.ruleItem,
                                          callback: function($$v) {
                                            _vm.$set(item, "ruleItem", $$v)
                                          },
                                          expression: "item.ruleItem"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            value: "1",
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_BringForward"
                                            )
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            value: "2",
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Postpone"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-input", {
                                      staticStyle: {
                                        width: "50px",
                                        "margin-right": "5px"
                                      },
                                      attrs: {
                                        type: "number",
                                        oninput:
                                          "value=value.replace(/[^\\d]/g,'')"
                                      },
                                      model: {
                                        value: item.duration,
                                        callback: function($$v) {
                                          _vm.$set(item, "duration", $$v)
                                        },
                                        expression: "item.duration"
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("Pricing.Hour")))
                                    ]),
                                    _c("el-input-number", {
                                      staticStyle: {
                                        width: "50px",
                                        "margin-left": "5px",
                                        "margin-right": "5px"
                                      },
                                      attrs: {
                                        type: "number",
                                        min: 0,
                                        max: 59,
                                        step: 1,
                                        controls: false
                                      },
                                      model: {
                                        value: item.minute,
                                        callback: function($$v) {
                                          _vm.$set(item, "minute", $$v)
                                        },
                                        expression: "item.minute"
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_EarlyWarningReminder"
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_WarningLevel")
                            }
                          },
                          _vm._l(_vm.levels, function(item2) {
                            return _c(
                              "el-radio-group",
                              {
                                key: item2.code,
                                model: {
                                  value: item.level,
                                  callback: function($$v) {
                                    _vm.$set(item, "level", $$v)
                                  },
                                  expression: "item.level"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: { label: item2.code }
                                  },
                                  [_vm._v(_vm._s(item2.chineseName))]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            staticStyle: { "margin-top": "20px" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SetAlertNotificationObject"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "10px" } },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        item.notifierRoles = ""
                                      }
                                    },
                                    model: {
                                      value: item._ext.hasDesignatedPost,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item._ext,
                                          "hasDesignatedPost",
                                          $$v
                                        )
                                      },
                                      expression: "item._ext.hasDesignatedPost"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_DesignatedPost")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-checkbox-group",
                              {
                                attrs: {
                                  value: _vm.toArray(item.notifierRoles),
                                  disabled: !item._ext.hasDesignatedPost
                                },
                                on: {
                                  input: function(val) {
                                    item.notifierRoles = _vm.toTxt(val)
                                  }
                                }
                              },
                              _vm._l(_vm.roles, function(item, index) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: index,
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: { label: item.code }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isZh
                                          ? item.chineseName
                                          : item.englishName
                                      )
                                    )
                                  ]
                                )
                              }),
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        !item.notifierRoles &&
                                        !item.notifySuperior
                                    },
                                    model: {
                                      value: item.notifySuperior,
                                      callback: function($$v) {
                                        _vm.$set(item, "notifySuperior", $$v)
                                      },
                                      expression: "item.notifySuperior"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.NotifySuperiors"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isPlatform,
                                    expression: "!isPlatform"
                                  }
                                ],
                                staticStyle: { "margin-top": "10px" }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        item.notifierIds = ""
                                      }
                                    },
                                    model: {
                                      value: item._ext.hasNotifierIds,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item._ext,
                                          "hasNotifierIds",
                                          $$v
                                        )
                                      },
                                      expression: "item._ext.hasNotifierIds"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_DesignatedPersonnel"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  staticStyle: {
                                    width: "205px",
                                    "margin-top": "10px"
                                  },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_User,
                                    fields: ["chineseName"],
                                    disabled: !item._ext.hasNotifierIds,
                                    "callback-params": { key: "userList" },
                                    "callback-method-type": "value",
                                    "tag-value": "userId",
                                    "tag-name": "chineseName",
                                    "filter-tag-names": ["chineseName"],
                                    "method-params": {
                                      pageSize: 1000000,
                                      active: true,
                                      hasRole: true
                                    },
                                    "default-multiple-value": _vm.toArray(
                                      item.notifierIds
                                    ),
                                    multiple: "",
                                    filterable: "",
                                    "options-width": "230px"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      item.notifierIds = _vm.toTxt(p.value)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "10px" } },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { value: !!item.enableMail },
                                    on: {
                                      input: function(val) {
                                        item.enableMail = val ? 1 : 0
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { value: !!item.enableWeChat },
                                    on: {
                                      input: function(val) {
                                        item.enableWeChat = val ? 1 : 0
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Wechat"))
                                    )
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-warning icon-tip",
                                  on: {
                                    click: function($event) {
                                      _vm.dialogVisible = true
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            item.enableMail
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.MailServer"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "200px" },
                                        model: {
                                          value: item.mailServerType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "mailServerType",
                                              $$v
                                            )
                                          },
                                          expression: "item.mailServerType"
                                        }
                                      },
                                      _vm._l(_vm.mailServers, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.code,
                                            label: item.chineseName
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "sea-house-dialog",
          staticStyle: { width: "2000px" },
          attrs: {
            no: "MattersNeedingAttention",
            visible: _vm.dialogVisible,
            title: _vm.$t("Message.Tip")
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-txt" }, [
            _c("h6", [
              _c("i", { staticClass: "el-icon-warning icon-tip" }),
              _vm._v(_vm._s(_vm.$t("SeaExport.WechatPrompt")))
            ]),
            _c("img", {
              staticStyle: { width: "300px", height: "300px" },
              attrs: { src: require("@/assets/WechatPrompt_1.png") }
            }),
            _c("img", {
              staticStyle: { width: "250px", height: "300px" },
              attrs: { src: require("@/assets/WechatPrompt_2.png") }
            }),
            _c("img", {
              staticStyle: {
                width: "300px",
                position: "absolute",
                left: "65%",
                top: "50%",
                "margin-left": "-60px",
                "margin-top": "-20px"
              },
              attrs: { src: require("@/assets/WechatPrompt_3.png") }
            })
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }